import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { useDispatch, useSelector } from 'react-redux';
import env from '@travel/env';
import { pushLocation } from 'store/__router/actions';
import styles from './infoTags.module.scss';

import { getSearchEngine } from 'store/searchEngine/selectors';

const InfoTags = () => {
  const envName = env('UNIVERSAL_ENV_NAME');
  const isDisplaySearchEngine = env('UNIVERSAL_SEARCH_ENGINE_TYPE') === 'true';

  const searchEngine = useSelector(getSearchEngine);
  const dispatch = useDispatch();
  const [btnPos, setBtnPos] = useState({ top: 0, left: 0 });

  const isInfoTagsEnabled = isDisplaySearchEngine || envName;

  useEffect(() => {
    if (isInfoTagsEnabled) {
      const logoElem = document.querySelector('.rt-common-logo');
      const headerElem = document.querySelector('.rt-common-header-wrapper');
      if (headerElem) {
        (headerElem as HTMLElement).style.position = 'relative';
      }
      const calculatePosition = () => {
        if (logoElem) {
          const rect = logoElem.getBoundingClientRect();
          setBtnPos({ top: rect.top + 10, left: rect.right + 10 });
        }
      };

      // Wait for layout to stabilize
      const timeoutId = setTimeout(calculatePosition, 200);
      return () => clearTimeout(timeoutId);
    }
  }, [isInfoTagsEnabled]);

  return isInfoTagsEnabled ? (
    <div
      style={{
        top: btnPos.top,
        left: btnPos.left,
        display: btnPos.top ? 'flex' : 'none',
      }}
      className={styles.infoWrapper}
      data-testid="InfoTags-wrapper"
    >
      {envName && (
        <button
          data-testid="app-env-button"
          class={styles.envButton}
          tabIndex={-1}
          onClick={() => {
            dispatch(
              pushLocation(
                window.location.pathname.replace(env('UNIVERSAL_BASE_NAME') as string, '') +
                  window.location.search,
              ),
            );
          }}
        >
          {envName}
        </button>
      )}
      {isDisplaySearchEngine && searchEngine && (
        <span class={styles.searchEngine} data-testid="app-searchEngine-info">
          {searchEngine}
        </span>
      )}
    </div>
  ) : null;
};

export default InfoTags;
